import { render, staticRenderFns } from "./SwiftScan.vue?vue&type=template&id=4ed9ad26&"
import script from "./SwiftScan.vue?vue&type=script&lang=js&"
export * from "./SwiftScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports